<template>
    <DModal
        :show="showModal"
        :title="__('orders.check.automatic_checks_tab.add_reason_title')"
        is-confirm
        :is-awaiting-validation="true"
        @update:show="$emit('update:showModal', $event)"
        @confirm="saveReason"
        @close="$emit('close-modal')"
    >
        <DCard padding>
            <DFormRow :label="__('orders.check.automatic_checks_tab.reason')">
                <DInput
                    id="order-reason"
                    v-model="form.reason"
                />
                <p
                    v-for="(error, index) in errors"
                    :key="index"
                    class="error-msg"
                >
                    {{ error }}
                </p>
            </DFormRow>
        </DCard>
    </DModal>
</template>

<script>

export default {
    name: 'OrderAutomaticCheckReason',
    props: {
        item: {
            type: Object,
            default: () => { return {} }
        },
        order: {
            type: Object,
            default: () => { return {} }
        },
        showModal: {
            type: Boolean,
            default: false
        }
    },
    emits: ['close-modal', 'update:showModal'],
    data () {
        return {
            form: this.$inertia.form({
                field: this.item.field,
                reason: this.item.reason
            }),
            errors: {}
        }
    },
    methods: {
        saveReason () {
            this.$inertia.post(
                this.$route('orders.psa.save-automatic-check-reason', {
                    order: this.order.orderData.id
                })
                ,
                this.form,
                {
                    onSuccess: () => {
                        this.$emit('close-modal')
                    },
                    onError: (error) => {
                        this.errors = error
                    }
                }
            )
        }
    }
}
</script>

<style scoped>
.error-msg {
    margin: 3px 0 0 0;
    font-size: 12px;
    color: var(--colorDanger);
}
</style>
